//
// Column.js
// commons
//
// Generated by Robots v0.
// Copyright (c) SAS Institute Inc. All rights reserved.
//
// DO NOT EDIT THIS FILE. IT IS GENERATED BY ROBOTS.
//
// Disable camelcase rule for generated code.
/* eslint-disable camelcase */
import { createModule } from "../../../moduleBuilder";
import EventDispatcher from "../../../events/EventDispatcher";
import "../../../lib";
import "./Variable";
import "./DataUsage";
import "../DataValue";

var Column = createModule("commons_Column", [167,27], EventDispatcher, [
    {
        VALUE_CHANGED: 10010,
        RANGE_CHANGED: 10011,
    },
    ,
    ,
    {
        total: 6,
        strings: [7],
        stringIndices: [4],
        numbers: [6],
        numberOfRows: 3,
        dataUsage: 4,
    },
    {
        getMissingValueIndices: [[3]],
        getMaximumString: [7],
        setNumberAtIndex: [0,6,4,2],
        setStringAtIndex: [0,7,4,2],
        containsAllOther: [2],
        getDataValueAtIndex: [1,3,2],
        getStringAtIndex: [7,3],
        getMaximumNumber: [6],
        getFormattedTotal: [7],
        getFormattedValueAtIndex: [7,3,2],
        getUniqueFormattedValueIndices: [[3]],
        containsMissing: [2],
        getDataValuesAtIndices: [[1],[3],2],
        containsMatchesAll: [2],
        getMinimumNumber: [6],
        getFormattedValues: [[7]],
        getNumberAtIndex: [6,3],
    },
    {
        _create_v: [4],
        _create_ssnnn: [4,7,7,4,4,4],
    },
    ,
    ["_create"]
]);
export default Column;
